import { translate } from "@utils";

import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";

export const PolicyFormSeveritiesSelect = ({ viewOnly = false, activePolicy, setActivePolicy }) => {
	const handleSelection = (e) => {
		setActivePolicy((prevState) => {
			let severities = prevState.severities;
			let severity = e.target.id.split(".")[1];
			if (e.target.checked) severities = [...new Set([...severities, severity])];
			else severities = severities.filter((s) => s !== severity);
			return { ...prevState, severities };
		});
	};

	return (
		<div>
			<h5>{translate("severities")}</h5>
			<FormGroup style={{ display: "flex", flexDirection: "row" }}>
				<FormControlLabel
					control={<Checkbox id="policyForm-severity.critical" disabled={viewOnly} checked={activePolicy.severities.includes("critical") ? true : false} onChange={handleSelection} />}
					label={translate("critical")}
				/>
				<FormControlLabel
					control={<Checkbox id="policyForm-severity.high" disabled={viewOnly} checked={activePolicy.severities.includes("high") ? true : false} onChange={handleSelection} />}
					label={translate("high")}
				/>
				<FormControlLabel
					control={<Checkbox id="policyForm-severity.medium" disabled={viewOnly} checked={activePolicy.severities.includes("medium") ? true : false} onChange={handleSelection} />}
					label={translate("medium")}
				/>
				<FormControlLabel
					control={<Checkbox id="policyForm-severity.low" disabled={viewOnly} checked={activePolicy.severities.includes("low") ? true : false} onChange={handleSelection} />}
					label={translate("low")}
				/>
			</FormGroup>
		</div>
	);
};
